import { Brick, registerBrick } from 'olympe';
import {formatFilterOptionsForAPI} from './_filters';

export default class FormatSelectedFiltersForAPI extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} selectedFilters
     * @param {function()} forwardEvent
     * @param {function(string)} setSerializedFilters
     */
    update($, [selectedFilters], [forwardEvent, setSerializedFilters]) {
        const serialized = {};
        for (const filterKey in selectedFilters) {
            serialized[filterKey] = selectedFilters[filterKey] ? formatFilterOptionsForAPI(filterKey, selectedFilters[filterKey].values) : [];
        }
        setSerializedFilters(JSON.stringify(serialized));
        forwardEvent();
    }
}

registerBrick('0188053e8dee07a8baf0', FormatSelectedFiltersForAPI);
